import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from '@reservamos/elements';

/**
 * ActionFooter component.
 * @param {object} props - label, itemCount, buttonText, onButtonClick.
 * @param {string} props.label - Footer label text.
 * @param {number} props.itemCount - Number of items to display in counter.
 * @param {string} props.buttonText - Button call-to-action text.
 * @param {function} props.onButtonClick - Callback when button is clicked.
 */
const ActionFooter = ({ label, itemCount, buttonText, onButtonClick }) => {
  const isEmpty = itemCount === 0;

  return (
    <div className="bg-primary-regular px-4 py-3 rounded-full w-full flex justify-between items-center">
      <Text elementType="span" color="white" weight="semibold">
        {label}
      </Text>
      <Button hideShadow isRounded withHeight onClick={onButtonClick}>
        <span className="flex gap-1 items-center justify-center">
          {!isEmpty && (
            <span className="bg-accent-regular rounded-full justify-center items-center flex h-7 w-7">
              <Text elementType="span" color="white" weight="semibold">
                {itemCount}
              </Text>
            </span>
          )}
          <Text elementType="span">{buttonText}</Text>
        </span>
      </Button>
    </div>
  );
};

ActionFooter.propTypes = {
  label: PropTypes.string,
  itemCount: PropTypes.number,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
};

ActionFooter.defaultProps = {
  label: '',
  itemCount: 0,
  buttonText: '',
  onButtonClick: () => {
    // no-op default handler
  },
};

export default ActionFooter;
